import { createSetting, VALUE_TYPE_PERCENTAGE } from './setting';

export default {
  transporte: createSetting('Transporte', VALUE_TYPE_PERCENTAGE),
  salario: createSetting('Salário', VALUE_TYPE_PERCENTAGE),
  beneficios: createSetting('Cesta de Benefícios', VALUE_TYPE_PERCENTAGE),
  ajudaCusto: createSetting('Ajuda de Custo', VALUE_TYPE_PERCENTAGE),
  taxaAdm: createSetting('Taxa Adm.', VALUE_TYPE_PERCENTAGE),
};
